import { auth } from '../firebase';

export class AuthenticatedFetchError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'AuthenticatedFetchError';
    this.status = status;
  }
}

export async function authenticatedFetch(
  input: RequestInfo | URL,
  init: RequestInit = {}
): Promise<Response> {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new AuthenticatedFetchError('Please sign in to continue.', 401);
  }

  const idToken = await currentUser.getIdToken();
  const headers = new Headers(init.headers || {});
  headers.set('Authorization', `Bearer ${idToken}`);

  const response = await fetch(input, {
    ...init,
    headers,
  });

  return response;
}

export async function readErrorMessage(response: Response, fallback: string): Promise<string> {
  try {
    const data = (await response.json()) as { error?: string };
    if (data?.error && typeof data.error === 'string') return data.error;
  } catch {
    // ignore parse failures
  }
  return fallback;
}
